




import Vue from 'vue';
import OrganizationList from '@/components/organizations/organization-list.component.vue';

export default Vue.extend({
  components: {
    'organization-list': OrganizationList,
  },
});
